import * as React from "react";
const SvgArrowUp = (props) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "#0B4566", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 20L13.4 21.4L19 15.8L19 28L21 28L21 15.8L26.6 21.4L28 20L20 12L12 20Z", fill: "#0B4566" }));
export default SvgArrowUp;
